import React from "react";

import SearchCard from "../../widgets/SearchCard/SearchCard";
import {
  AGENT_PHONE_SEARCH_CARD_CONFIG,
  AGENT_PHONE_SEARCH_CONFIG,
  AGENT_PHONE_SEARCH_FIELD,
  AGENT_SEARCH_PAGE_TITLE,
  AGENT_SEARCH_SUBMIT_LABEL,
} from "../../constants/constants";
import styles from "./ManageAgent.module.scss";

const ManageAgent = ({
  values,
  handleChange,
  handleSubmit,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  setFieldValue,
}) => {
  return (
    <div className={styles.manageAgentWrapper}>
      <div className={styles.card}>
        <h2 className={styles.title}>{AGENT_SEARCH_PAGE_TITLE}</h2>

        <form onSubmit={handleSubmit}>
          <SearchCard
            tabs={AGENT_PHONE_SEARCH_CARD_CONFIG}
            activeCard={AGENT_PHONE_SEARCH_FIELD}
            config={AGENT_PHONE_SEARCH_CONFIG}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            errors={errors}
            touched={touched}
            handleBlur={handleBlur}
            isLoading={isSubmitting}
            submitButtonLabel={AGENT_SEARCH_SUBMIT_LABEL}
            showTabHeader={false}
            showIsdSelector={false}
          />
        </form>
      </div>
    </div>
  );
};

export default ManageAgent;
